import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';

import signInBackgroundImg from '../../assets/bg-auth.jpg';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;

  display: flex;
  align-items: stretch;
`;

export const Background = styled.div`
  flex: 1;
  background: url(${signInBackgroundImg}) no-repeat center;
  background-size: cover;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items: center;

  width: 100%;
  max-width: 700px;
`;

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transforme: translateX(-50px);
  }
  to{
    opacity: 1;
    transforme: translateX(0);
  }
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items: center;

  animation: ${appearFromLeft} 1s;

  img{
    max-width: 220px;
  }

  @media (max-width: 540px) {
    img{
      padding-top: 16px;
      max-width: 50%;
    }
  }

  form{
    margin: 24px 0;
    width: 288px;
    text-align: center;

    h1{
      font-size: 24px;
      margin-bottom: 16px;
    }

    a{
      display: block;
      text-decoration: none;
      color: var(--color-primary);
      margin-top: 24px;
      transition: color 0.2s;

      &:hover{
        color: var(--color-primary-h);
      }
    }

    @media (max-width: 540px) {
      h1{ display: none; }
    }
  }

  > a{
    display: block;
    text-decoration: none;
    margin-top: 24px;
    color: #FF9000;

    display: flex;
    align-items: center;
    transition: color 0.2s;

    &:hover{
      color: ${shade(0.2, '#FF9000')}
    }
    svg{
      margin-right: 16px;

    }
  }
`;
export const WrapperInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  border-top: 1px solid var(--color-border);
  padding: 16px 0;
  h3{
    font-size: 1em;
  }
  a{
    margin-top: 0 !important;
  }
`;
export const LinkInfo = styled.div`
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg{
      margin-right: 8px;
      font-size: 18px;
    }
`;
